module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " padding-left-30 padding-right-30"
  }, [_c('div', {
    staticClass: "vctb-list"
  }, [_c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.vctbIndex = 0
      }
    }
  }, [_vm._v("\n\t\t\t工商信息\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.vctbIndex = 1
      }
    }
  }, [_vm._v("\n\t\t\t股东信息 (" + _vm._s(_vm.totalnum) + ")\n\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: " padding-left-10 padding-right-10"
  }, [(_vm.vctbIndex == 0) ? [_c('table', {
    staticClass: "pure-table pure-table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "15%",
      "background": "#F7F7F7"
    }
  }, [_vm._v("统一社会信用代码")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.code ? _vm.detail.code : '--'))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%",
      "background": "#F7F7F7"
    }
  }, [_vm._v("注册号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.industry_number ? _vm.detail.industry_number : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("组织机构代码")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.organi_code ? _vm.detail.organi_code : '--'))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("经营状态")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.operate_status ? _vm.detail.operate_status : '--') + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v(" 法定代表人\n\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.detail.legal ? _vm.detail.legal : '--') + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("注册资本")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.capital ? _vm.detail.capital : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("企业类型")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": ""
    }
  }, [_vm._v(_vm._s(_vm.detail.com_type ? _vm.detail.com_type : '--'))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("成立日期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": ""
    }
  }, [_vm._v(_vm._s(_vm.detail.date ? _vm.detail.date : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("营业期限")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.business_term ? _vm.detail.business_term : '--'))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("登记机关")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.register_local ? _vm.detail.register_local : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("核准日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.approval_date ? _vm.detail.approval_date : '--'))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("公司规模")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.people_size ? _vm.detail.people_size : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("参保人数")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.insure_number ? _vm.detail.insure_number : '0') + "人")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("年营业额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.tax_number ? _vm.detail.tax_number : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("所属行业")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detail.industry ? _vm.detail.industry : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("通讯地址")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detail.address ? _vm.detail.address : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("注册地址")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detail.new_address ? _vm.detail.new_address : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("最新注册地址变更日期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detail.addressLastChangeDate ? _vm.detail.addressLastChangeDate : '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("经营范围")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.detail.business ? _vm.detail.business : '--'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "height-30"
  })] : _vm._e(), _vm._v(" "), (_vm.vctbIndex == 1) ? [(_vm.detail) ? _c('div', [_c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text2 text-bold ",
    staticStyle: {
      "flex": "2"
    }
  }, [_vm._v("股东(发起人)\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold "
  }, [_vm._v("持股比例\n\t\t\t\t\t\t"), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "默认采用认缴出资金额计算",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning-outline margin-left-4"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("认缴出资金额 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("认缴出资日期 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("实缴出资金额 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("实缴出资日期 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold width-80 justify-center",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.shareholder), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text2  ",
      staticStyle: {
        "flex": "2"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  "
    }, [_vm._v(_vm._s(item.share_rate || "0%") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  "
    }, [_vm._v(_vm._s(item.money))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  "
    }, [_vm._v(_vm._s(item.date || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  "
    }, [_vm._v(_vm._s(item.payedNumber || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  "
    }, [_vm._v(_vm._s(item.payedDate || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  justify-center  width-80  ",
      staticStyle: {
        "flex": "none"
      }
    }, [_c('span', {
      staticClass: "cpoint",
      staticStyle: {
        "color": "#0070c0"
      },
      on: {
        "click": function($event) {
          return _vm.showShareholder(item)
        }
      }
    }, [_vm._v("详情")])])])
  }), _vm._v(" "), (!_vm.shareholder.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "30px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": function($event) {
        return _vm.handleCurrentChange($event)
      }
    }
  })], 1)], 2) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "股东信息",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('table', {
    staticClass: "pure-table pure-table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "40%",
      "background": "#F7F7F7"
    }
  }, [_vm._v("股东(发起人)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.name || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("持股比例")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.share_rate || "0%"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("认缴出资方式")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.planPayedMode || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("认缴出资金额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.money || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("认缴出资日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.date || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("认缴公式日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.publicDate || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("实缴出资方式")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.payedMode || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("实缴出资金额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.payedNumber || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("实缴出资日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.payedDate || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("实缴公式日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shareholderData.planPublicDate || '--'))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74113073"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/components/detail-page.vue
// module id = 900
// module chunks = 1